module.exports = ".sooneat-forget-pass {\n  background-color: #fff; }\n"